"use client";
import Image from "next/image";
import HowToApply from "./HowToApply";
import ThankYouHeader from "./ThankYouHeader";
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import {
  maxWidthContainer,
  fullWidthContainer,
} from "@/components/CourseContent/styles/constants";
import CrossSell from "./CrossSell";
import useDegreeTYPage from "@/monarch/rules/degreeTYPage/useDegreeTYPage";
import type { Program } from "@/common/program/types";
import useTranslations from "@/i18n/useTranslations";

interface DegreeTYClientProps {
  degreeData: Program;
  path: string;
  applicationUrl: string;
  courseImage: string;
  thankYouContent: {
    mainHeading: string;
    descriptionText: string;
  };
}

export default function DegreeTYClient({
  degreeData,
  path,
  applicationUrl,
  courseImage,
  thankYouContent,
}: DegreeTYClientProps) {
  const t = useTranslations("Common");
  const { isLoading, header, crossSellSection, applyInstructionsSection } =
    useDegreeTYPage();

  if (!isLoading) {
    return (
      <>
        <div className="relative md:pt-[95px] md:pb-[127px] pb-12 py-12 mb-16 bg-opacity-65 bg-black">
          <Image
            src={courseImage || ""}
            layout="fill"
            alt={t("backgroundImageAlt")}
            className="absolute z-[-1] object-cover object-center"
          />
          <div className={`${maxWidthContainer} ${fullWidthContainer} gap-8`}>
            <div className="w-full flex justify-start">
              <Breadcrumbs
                path={path}
                pageName={degreeData.title}
                linksToShowOnSmallScreen={1}
                containerClassName="not-prose"
              />
            </div>
            <div className="w-full">
              <ThankYouHeader
                program={degreeData}
                mainHeading={header?.title || thankYouContent.mainHeading}
                descriptionText={
                  header?.paragraph || thankYouContent.descriptionText
                }
                applicationUrl={applicationUrl}
              />
            </div>
          </div>
        </div>
        <div
          className={`${maxWidthContainer} ${fullWidthContainer} gap-12 sm:gap-16`}
        >
          <HowToApply title={applyInstructionsSection?.title} />
          <CrossSell
            degreeData={degreeData}
            title={crossSellSection?.title}
            subtitle={crossSellSection?.subTitle}
          />
        </div>
      </>
    );
  }
}
